import { CONFIRM_ACTION_NOTIFICATION, CONTRAINTE_DELETE_NOTIFICATION, CONTRAINTE_NOTIFICATION, DUPLICATION_NOTIFICATION, RESET_CONFIRM_ACTIONS } from '../constants/actionTypes.js'

export default (notifications = { contraintes : [], duplications : [], confirmActions : []}, action) => {
    switch(action.type){
        case CONTRAINTE_NOTIFICATION:
            return {...notifications, contraintes : notifications.contraintes.concat([({...action.payload})])}
        case CONTRAINTE_DELETE_NOTIFICATION:
            return {...notifications, contraintes : notifications.contraintes.filter(c => c.idObject !== action.payload)}
        case DUPLICATION_NOTIFICATION:
            return {...notifications, duplications : notifications.duplications.concat([({...action.payload})])}
        case CONFIRM_ACTION_NOTIFICATION:
            return {...notifications, confirmActions : notifications.confirmActions.concat([({...action.payload})])}
        case RESET_CONFIRM_ACTIONS:
            return { ...notifications, confirmActions: [] };
        default :
            return notifications
    }
}